import {
  PAGE_LIST_LOADING,
  GET_PAGE_LIST_ERROR,
  GET_PAGE_LIST,
  GET_PAGE_BY_ID_LOADING,
  GET_PAGE_BY_ID_SUCCESS,
  GET_PAGE_BY_ID_ERROR,
  DELETEING_PAGE,
  DELETE_PAGE,
  DELETE_PAGE_ERROR,
  DELETED_PAGE_LIST_LOADING,
  GET_DELETED_PAGE_LIST,
  GET_DELETED_PAGE_LIST_ERROR,
  PERMA_DELETEING_PAGE,
  PERMA_DELETE_PAGE,
  PERMA_DELETE_PAGE_ERROR,
  RESTORE_PAGE_LIST_LOADING,
  RESTORE_PAGE_LIST,
  RESTORE_PAGE_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_PAGE_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_PAGE:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_PAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_PAGE:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_PAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_PAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_PAGE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case GET_DELETED_PAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case DELETE_PAGE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_PAGE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case RESTORE_PAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_PAGE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_PAGE_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_PAGE_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_PAGE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_PAGE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_PAGE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;